import cn from 'classnames';
import React, { memo } from 'react';

import { useIsMobile } from '@sravni/react-utils';

// import Toggle from '@src/components/PageHeader/PageHeaderSubheading/Toggle';
import { useBranding } from '@src/reducers/branding';

import { useHeadingTexts } from '../hooks';

import style from './style.module.scss';

export const PageHeaderSubHeading: React.FC<{ isHidden?: boolean }> = memo(
  ({ isHidden }: { isHidden: boolean } = { isHidden: false }) => {
    const isMobile = useIsMobile();

    const { desktop, mobile } = useBranding() || {};
    const { creditCalculator = {} } = (isMobile ? mobile : desktop) || {};
    const { mainTextColor, regionTextColor } = creditCalculator;
    // const isDesktop = !isMobile;
    const replacements = useHeadingTexts().subHeadingText;

    const subHeader = React.useMemo(() => replacements, [replacements]);

    // const [isOpen, toggleIsOpen] = React.useState(false);

    // const clickOnToggle = React.useCallback(() => toggleIsOpen((open) => !open), []);

    const componentStyle = React.useMemo(
      () =>
        ({
          '--branding-text-color': regionTextColor || mainTextColor,
        }) as React.CSSProperties,
      [mainTextColor, regionTextColor],
    );

    return (
      <div className={cn(style.wrapper)} style={componentStyle}>
        <div
          className={cn(style.text, {
            // [style.hidden]: !(isOpen || isDesktop),
            [style.textColor]: regionTextColor || mainTextColor,
          })}
        >
          {subHeader}
        </div>
        {/* {!isHidden && <Toggle text="Eщё" isOpen={isOpen} onClick={clickOnToggle} />} */}
      </div>
    );
  },
);
